import React, { CSSProperties, ReactNode } from "react";
import Pill from "@ingka/pill";

import "@ingka/svg-icon/dist/style.css";
import "@ingka/pill/dist/style.css";
import "@ingka/focus/dist/style.css";

type FixaPillProps = {
  id?: string;
  "data-testid"?: string;
  disabled?: boolean;
  label?: ReactNode;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  selected?: boolean;
  size?: "xsmall" | "small" | "medium";
  leadingIcon?: (prefix?: string) => React.SVGProps<SVGElement>[];
  trailingIcon?: (prefix?: string) => React.SVGProps<SVGElement>[];
  style?: CSSProperties;
  tabIndex?: number;
};

function FixaPill(props: FixaPillProps) {
  return <Pill {...props} />;
}

export default FixaPill;
